module.exports = __webpack_public_path__ + "static/img/6.01277882.jpg";